<svg
    width="311"
    height="187"
    viewBox="0 0 311 187"
    xmlns="http://www.w3.org/2000/svg">
    <svg:path
        class="outer-roof"
        d="M310 66 L108 186 L1 122 L201 1 L310 66 Z" />

    <!-- Roof -->
    <svg:path
        d="M17 121 L110 177 L295 66 L201 10 L17 121Z"
        [attr.fill]="'var(--roof-bg)'" />

    <g
        [x]="70"
        [y]="-45"
        app-roof-box></g>

    <g
        [x]="-70"
        [y]="40"
        app-roof-box></g>

    <g
        [x]="100"
        [y]="-30"
        app-roof-vent></g>

    <g
        [x]="50"
        [y]="0"
        app-roof-vent></g>
</svg>
